import axios from 'axios';
import {pathConstants} from "../../../shared/pathConstants";


export default {
    getReleaseNotes() {
        return axios.get(pathConstants.API +`/releaseNotes`)
            .then(response => response.data);
    }
};